import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from '@/components/ui/popover';
import { signOut, useSession } from 'next-auth/react';
import { SwitchAgentIDModal } from './switch-agent-id-modal';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

export function AgentIdNavMenu() {
  const session = useSession();
  const [agentIdMenuOpen, setAgentIdMenuOpen] = useState(false);

  const handleSignOut = () => {
    signOut({ callbackUrl: '/' });
    sessionStorage.clear();
  };

  const handleNavClose = () => {
    setAgentIdMenuOpen(false);
  };

  return (
    <Popover open={agentIdMenuOpen} onOpenChange={setAgentIdMenuOpen}>
      <PopoverTrigger className="gap-3">
        <div className="flex flex-row-reverse items-center gap-3">
          <ChevronDown
            className="relative w-5 transition duration-200 stroke-tomato-600"
            aria-hidden="true"
            strokeWidth={4}
          />
          <p className="font-effra text-blue-900 text-base font-bold underline">
            Writing code: {session.data?.user?.agentId}
          </p>
        </div>
      </PopoverTrigger>
      <PopoverContent>
        <div className="flex flex-col w-[300px] p-7 gap-7">
          <SwitchAgentIDModal closeNav={handleNavClose} />
          <div className="flex justify-end">
            <Button
              variant="secondary"
              className="p-3 text-md/150"
              onClick={handleSignOut}
              data-ta="switch-agent-id-modal-sign-out"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
